import React, { useState } from 'react'
import { Outlet, useLocation, useMatch } from 'react-router-dom'
import { Box, Typography, Button, Menu, MenuItem } from '@mui/material'
import { OpenInNew } from '@mui/icons-material'
import { Navbar } from 'react-bootstrap'
// import { DarkModeSwitch } from 'react-toggle-dark-mode'

import { isPrivate, appVersion } from '../utils/config'
import '../styles/css/header.css'
import fullLogoBlack from '../assets/pathomiq-ai-logo-black.webp'

const HeaderPage = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  // const [isDarkMode, setDarkMode] = useState<boolean>(Boolean(localStorage.getItem('darkmode')?.valueOf))

  const open = Boolean(anchorEl)
  const location = useLocation()

  const isViewerRoute = Boolean(useMatch('/viewer/:imageId'))

  const isAdmin = /admin|superadmin|dev/i.test(localStorage.getItem('role') || 'user')
  const isDev = /dev/i.test(localStorage.getItem('role') || 'user')
  
  const handleClick = (e: any) => setAnchorEl(e.currentTarget)
  const handleClose = () => setAnchorEl(null)

  // const toggleDarkMode = () => {
  //   const darkmode = localStorage.getItem('darkmode')?.valueOf() === 'true'
  //   if (darkmode) localStorage.setItem('darkmode', 'false')
  //   else localStorage.setItem('darkmode', 'true')
  //   setDarkMode(localStorage.getItem('darkmode')?.valueOf() === 'true')
  // }

  return (
    <>
      <Navbar className='position-sticky px-4 d-flex justify-content-between gap-5' bg='light' expand='lg' fixed='top'>
        <Navbar.Brand className='d-flex align-items-center gap-3' href='../dashboard'>
          <img src={fullLogoBlack} height={22} alt="PATHOMIQ AI"/>
          <Typography id='logo-text-desc' sx={{fontSize: '0.8rem'}} className='text-secondary'>AI Powered Cancer Diagnosis and Treatment Response Predictions</Typography>
        </Navbar.Brand>
        <Box className='d-flex align-items-center gap-3'>
          <Typography id='app-version-text' className='text-secondary' variant='caption'>{appVersion}{isPrivate && ' Internal'}</Typography>
          {!isViewerRoute
            ? <>
              <Button className='text-capitalize fs-6 fw-normal' onClick={handleClick} color="inherit" 
                aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined}
              >
                My account
              </Button>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose} MenuListProps={{'aria-labelledby': 'nav-button'}}>
                <MenuItem className='px-4 py-2' component='a' href="../home" selected={location.pathname === '/home'}>Home</MenuItem>
                {(isPrivate || isAdmin) && <MenuItem className='px-4 py-2' component='a' href="../dashboard" selected={location.pathname === '/dashboard'}>Dashboard</MenuItem>}
                {(isPrivate || isDev) && <MenuItem className='px-4 py-2' component='a' href="../patients" selected={location.pathname === '/patients'}>Patients</MenuItem>}
                {isPrivate && <MenuItem className='px-4 py-2' component='a' href="../cluster-expt" selected={location.pathname === '/cluster-expt'}>Cluster EXPT</MenuItem>}
                <MenuItem className='px-4 py-2' component='a' href="../profile" selected={location.pathname === '/profile'}>Profile</MenuItem>
                {(isAdmin || isPrivate) && <MenuItem className='px-4 py-2' component='a' href="../admin" selected={location.pathname === '/admin'}>Admin</MenuItem>}
                {/* <MenuItem className='px-4 py-2' onClick={toggleDarkMode}>
                  Theme&nbsp;&nbsp;&nbsp;&nbsp;<DarkModeSwitch checked={isDarkMode} size={24} />
                </MenuItem> */}
                <MenuItem className='px-4 py-2 gap-2' component='a' href="../help.html" target='_blank'>Doc<OpenInNew color="inherit" fontSize='small' /></MenuItem>
                <MenuItem sx={{ color: 'error.main' }} className='px-4 py-2' component='a' href="../logout" selected={location.pathname === '/logout'}>Logout</MenuItem>
              </Menu>
            </>
            : <Box sx={{height: 40}}></Box>
          }
        </Box>
      </Navbar>
      
      <Outlet />
    </>
  )
}

export default HeaderPage
